export default __webpack_public_path__ + "static/jockbrocas-77d716e4a76c2aff6e645495980b4da3.png";